import { render, staticRenderFns } from "./ReviewTypeDropdownField.vue?vue&type=template&id=63472d9e"
import script from "./ReviewTypeDropdownField.vue?vue&type=script&lang=ts"
export * from "./ReviewTypeDropdownField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63472d9e')) {
      api.createRecord('63472d9e', component.options)
    } else {
      api.reload('63472d9e', component.options)
    }
    module.hot.accept("./ReviewTypeDropdownField.vue?vue&type=template&id=63472d9e", function () {
      api.rerender('63472d9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Dropdowns/ReviewTypeDropdownField.vue"
export default component.exports